module.exports = __webpack_public_path__ + "img/State Auto_logo.d70eeb61.png";